module.exports = "img/flags/LK.8205129.png";